import { createFileRoute } from "@tanstack/react-router";
import { EsLegalPage, EsLegalSection } from "@/components/site/EsPage";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/legal/terminos")({
  head: () =>
    buildHead({
      title: "Términos y Condiciones — Simply Approved Mortgages",
      description:
        "Términos de uso de este sitio web. Información educativa únicamente; no constituye oferta de crédito ni aprobación de préstamo.",
      url: "/es/legal/terminos",
      locale: "es",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Términos", url: "/es/legal/terminos" },
      ],
    }),
  component: Page,
});

function Page() {
  return (
    <EsLegalPage
      title="Términos y condiciones"
      intro="Al usar este sitio, usted acepta estos términos. El contenido es informativo y no reemplaza el asesoramiento legal, financiero o fiscal profesional."
      enPath="/legal/terms"
      enLabel="Terms & Conditions"
    >
      <EsLegalSection heading="Uso del sitio">
        <p>
          Este sitio proporciona información educativa sobre programas de préstamos para
          inversionistas inmobiliarios con fines comerciales (business-purpose). No garantizamos que
          cualquier escenario califique, ni que las tasas, términos o montos mostrados estén
          disponibles para su situación específica.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="No es una oferta de crédito">
        <p>
          Nada en este sitio constituye una oferta de crédito, un compromiso de financiamiento, una
          aprobación de préstamo ni un contrato. Los términos reales se determinan después de la
          suscripción completa por parte del prestamista mayorista correspondiente.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Limitación de responsabilidad">
        <p>
          Simply Approved Mortgages LLC no es responsable de decisiones de inversión, compra de
          propiedad o financiamiento basadas en la información de este sitio. Consulte con
          profesionales calificados (hipotecario, legal, fiscal, contable) antes de actuar.
        </p>
      </EsLegalSection>
    </EsLegalPage>
  );
}
